import React from 'react';

const AddCart = () => {
    return (
        <button className="btn btn-primary">Add Cart</button>
    );
};

export default AddCart;